import type { QuoteFile } from '../types'
import { RESIZE_WIDTHS } from './getPrintImageWidth'

export function generateSrcSet({
  file,
  svg,
  size
}: {
  file: QuoteFile | undefined
  svg?: boolean
  size?: number
}): string | null {
  const regex = /(.*amazonaws\.com)/
  // a file with no `src`/`s3PublicKey` (e.g. an image slot that was never filled) has nothing to resize.
  // Callers treat null as "no srcSet available", so fail that way instead of throwing (#23950).
  if (!file?.src || !file.s3PublicKey || !file.src.match(regex)) {
    return null
  }
  const base = file.src.match(regex)[1]
  const fileIndex = file.s3PublicKey.lastIndexOf('/')
  const fileName = file.s3PublicKey.slice(fileIndex)
  const id = fileName.split('.')[0]
  const idIndex = file.s3PublicKey.indexOf(id)
  const dist = file.s3PublicKey.slice(0, idIndex)

  // Svg url
  if (svg) {
    return base + `/${dist}` + id + '/svg' + fileName
  }

  // Singular size url
  if (size) {
    return base + `/${dist}` + id + `/${size}` + fileName
  }

  // Resized srcSet
  const lines = RESIZE_WIDTHS.map((width) => {
    return base + `/${dist}` + `${id}` + `/${width}` + `${fileName}` + ` ${width}w`
  })
  return lines.join(', ')
}
